import {action, observable, computed, makeObservable} from 'mobx';
import fieldTexts from '../../TemplateReport/texts';

export abstract class Collection {
    fields;
    @observable isExpanded;
    parentCollection;
    newFieldsCounter;

    constructor(parent) {
        makeObservable(this);
        this.fields = observable.array([]);
        this.parentCollection = parent;
        this.newFieldsCounter = 0;
    }

    /* fields insertion should be processed in a screen specific Collection */
    abstract insertFields(field, children): void;

    get hasChildren() {
        return this.fields.length > 0;
    }

    get isEmpty() {
        return this.fields.length === 0;
    }

    get lastLevelFields() {
        return this.getLastLevelFields(this.fields);
    }

    get nextId() {
        return 'new_' + this.newFieldsCounter++;
    }

    //@computed
    get firstHiddenIdx() {
        const hiddenIdx = this.fields.findIndex(field => field.hidden);
        return hiddenIdx >= 0 ? hiddenIdx : this.fields.length;
    }

    //@computed
    get firstAvailableIdx() {
        return 0;
    }

    getNewTemplateTitle = currentNumber => {
        const {newTemplatetitle} = fieldTexts;

        const currentTitle = currentNumber
            ? `${newTemplatetitle}_${currentNumber}`
            : newTemplatetitle;

        //check if title already exists
        if (this.fields.find(fld => fld.title === currentTitle)) {
            return this.getNewTemplateTitle(currentNumber + 1);
        } else {
            return currentTitle;
        }
    };
    @computed get generatedTitle() {
        const {newTemplatetitle} = fieldTexts;

        //gets number of new templates with generated title
        const newTemplateslength = this.fields.filter(fld =>
            fld.title.includes(newTemplatetitle)
        ).length;

        //increment the template title number
        return this.getNewTemplateTitle(newTemplateslength);
    }

    getLastLevelFields(fields) {
        let res: any[] = [];
        for (const field of fields) {
            if (field.collection && field.collection.fields.length) {
                res = res.concat(this.getLastLevelFields(field.collection.fields));
            } else {
                res.push(field);
            }

            if (field.merge) {
                res.push(field.mergedField);
            }
        }
        return res;
    }

    toggleExpanded() {
        this.setExpanded(!this.isExpanded);
    }

    @action
    setExpanded(expanded) {
        if (expanded) {
            // expand parent collection too
            this.parentCollection && this.parentCollection.setExpanded(true);
            // run on sibling fields' collections and collapse them
            this.parentCollection &&
                this.parentCollection.fields.forEach(f => {
                    if (f.collection && f.collection !== this && f.collection.isExpanded) {
                        f.collection.setExpanded(false);
                    }
                });
            this.isExpanded = true;
        } else {
            // run on child collections, and collapse them
            this.fields.forEach(f => {
                f.collection && f.collection.isExpanded && f.collection.setExpanded(false);
            });
            this.isExpanded = false;
        }
    }

    //@computed
    /*expandedChild() {
		const child = this.fields.filter(c => c.isExpanded)[0];
		if(child && child.hasChildren) {
			return child.expandedChild || child;
		}
		return child;
	}*/

    @action deleteField(field) {
        this.fields.remove(field);
    }

    @action
    clearFields() {
        this.fields.clear();
    }

    @action
    moveField(field, dest) {
        const removedField = this.removeField(field);
        this.setField(removedField, dest);
    }

    @action
    removeField(field) {
        return this.fields.splice(this.fields.indexOf(field), 1)[0];
    }

    @action
    setField(field, idx) {
        this.fields.splice(idx, 0, field);
    }

    @action addField(field) {
        this.fields.unshift(field);
    }
}
